'use strict';

function PageTitleService($window, $timeout, auth) {
	let pageTitleService = {};
	pageTitleService.setPage = function (pageName) {
		$timeout(function () {
			const title =
				auth.user && auth.user.selectedSite
					? auth.user.selectedSite.displayName + ' | ' + pageName
					: '';
			$window.document.title = title;
		});
	};
	return pageTitleService;
}

PageTitleService.$inject = ['$window', '$timeout', 'auth'];

angular.module('PinMeTo.services').factory('pmtPageTitleService', PageTitleService);
